// extracted by mini-css-extract-plugin
export default {"BusinessList":"BusinessList_BusinessList__jIIy3","initalText":"BusinessList_initalText__g6RQK"};